import React from "react";
import { Text } from "@gcs/design-system/react";

import Button from "components/common/Button/Button";

import { ReactComponent as ExternalLinkIcon } from "assets/svgs/external-link-icon.svg";

import envs from "config/envs";

import * as S from "./SectionCorporativeGovernance.Style";

const SectionCorporativeGovernance = () => {
  return (
    <S.SectionCorporativeGovernanceContainer className="container">
      <S.SectionCorporativeGovernanceTitle>
        Governança Corporativa
      </S.SectionCorporativeGovernanceTitle>

      <S.SectionCorporativeGovernanceContent>
        <S.SectionCorporativeGovernanceProfile>
          <img
            src={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/director-profile-image-06.webp`}
            alt="Mulher sorrindo, com cabelos longos e lisos, usando blusa preta e colar com pingente oval rosa, em fundo escuro."
          />

          <S.SectionCorporativeGovernanceProfileContent>
            <S.SectionCorporativeGovernanceProfileTitle>
              Luane Fernandes
            </S.SectionCorporativeGovernanceProfileTitle>

            <S.SectionCorporativeGovernanceDescription>
              Superintendente Jurídico e Governança Corporativa
            </S.SectionCorporativeGovernanceDescription>
          </S.SectionCorporativeGovernanceProfileContent>
        </S.SectionCorporativeGovernanceProfile>

        <S.SectionCorporativeGovernanceDescription>
          <Text>
            A{" "}
            <strong>Superintendência Jurídica e Governança Corporativa</strong>{" "}
            assegura a <strong>gestão estratégica dos fóruns decisórios</strong>{" "}
            e a integridade do nosso modelo de governança. Coordenamos as
            agendas e o fluxo de informações do Conselho de Administração, da
            Diretoria Executiva e dos Comitês, promovendo{" "}
            <strong>
              transparência, rastreabilidade e aderência às melhores práticas de
              mercado e normas regulatórias
            </strong>
            .
          </Text>

          <Button
            as="a"
            size="lg"
            target="_blank"
            href={
              "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/Organograma_Governanca_2025.pdf"
            }
          >
            Conheça quem faz parte da área de Governança <ExternalLinkIcon />
          </Button>

          <Text>
            Também somos responsáveis pela <strong>gestão societária</strong>,
            fortalecendo a prestação de contas e a geração de valor de longo
            prazo. Em conjunto com a Diretoria de Conformidade e Proteção de
            Dados, promovemos em todas as subsidiárias da holding um ambiente
            ético, responsável e alinhado ao propósito e à cultura da companhia.
          </Text>
        </S.SectionCorporativeGovernanceDescription>
      </S.SectionCorporativeGovernanceContent>
    </S.SectionCorporativeGovernanceContainer>
  );
};

export default SectionCorporativeGovernance;
